import React, { ReactElement } from 'react';

type Props = {
  fill?: string;
};

function MomentiveLogoType({ fill = '#FFFFFF' }: Props): ReactElement {
  return (
    <svg
      data-testid="MomentiveLogoType"
      viewBox="0 0 123 18"
      width={123}
      height={18}
    >
      <g
        id="MomentiveLogoTypeGroup"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="MomentiveLogoTypeGroup2"
          transform="translate(0.000000, 0.875000)"
          fill={fill}
        >
          <path
            d="M122.02,6.988 L121.72,6.5745 C121.627,6.441 121.54,6.3145 121.467,6.1945 L121.453,6.201 C121.46,6.308 121.467,6.4945 121.467,6.6275 L121.467,7.4345 L121.047,7.4345 L121.047,5.501 L121.453,5.501 L122.02,6.288 L122.5865,5.501 L123,5.501 L123,7.4345 L122.573,7.4345 L122.573,6.6275 C122.573,6.4945 122.58,6.308 122.5865,6.201 L122.573,6.1945 C122.5,6.3145 122.4135,6.441 122.3205,6.5745 L122.02,6.988 Z M119.7665,5.8945 L119.2,5.8945 L119.2,5.501 L120.7665,5.501 L120.7665,5.8945 L120.2,5.8945 L120.2,7.4345 L119.7665,7.4345 L119.7665,5.8945 L119.7665,5.8945 Z"
            id="MomentiveLogoTypeGroupFill1"
          />
          <path
            d="M16.966,6.457 C16.2725,5.7175 15.3395,5.2145 14.009,5.2145 C12.4625,5.2145 10.9165,5.7945 9.396,6.426 C8.684,5.5965 7.947,5.2075 6.448,5.2075 C4.6795,5.2075 2.5345,5.791 0,6.7025 L0,16.8705 L2.7965,16.8705 L2.7965,7.719 L5.639,7.719 C6.1935,7.719 6.725,7.8805 7.118,8.32 C7.465,8.7125 7.58,9.221 7.58,10.215 L7.58,16.8705 L10.3765,16.8705 L10.3765,8.397 C10.3765,8.149 10.3765,7.923 10.355,7.719 L13.1965,7.719 C13.797,7.719 14.282,7.904 14.652,8.32 C14.9985,8.7125 15.1605,9.244 15.1605,10.215 L15.1605,16.8705 L17.957,16.8705 L17.957,9.7525 C17.957,8.158 17.659,7.2195 16.966,6.457"
            id="MomentiveLogoTypeGroupFill2"
          />
          <path
            d="M51.2535,6.457 C50.56,5.7175 49.627,5.2145 48.2965,5.2145 C46.75,5.2145 45.204,5.7945 43.6835,6.426 C42.9715,5.5965 42.2345,5.2075 40.7355,5.2075 C38.9675,5.2075 36.8225,5.791 34.2875,6.7025 L34.2875,16.8705 L37.084,16.8705 L37.084,7.719 L39.927,7.719 C40.4815,7.719 41.0125,7.8805 41.406,8.32 C41.7525,8.7125 41.8675,9.221 41.8675,10.215 L41.8675,16.8705 L44.664,16.8705 L44.664,8.397 C44.664,8.149 44.664,7.923 44.6425,7.719 L47.484,7.719 C48.0845,7.719 48.57,7.904 48.9395,8.32 C49.286,8.7125 49.448,9.244 49.448,10.215 L49.448,16.8705 L52.2445,16.8705 L52.2445,9.7525 C52.2445,8.158 51.947,7.2195 51.2535,6.457"
            id="MomentiveLogoTypeGroupFill3"
          />
          <path
            d="M26.046,14.675 C27.9875,14.675 29.42,13.15 29.42,11.1855 C29.42,9.221 27.9875,7.696 26.046,7.696 C24.1045,7.696 22.672,9.221 22.672,11.1855 C22.672,13.15 24.1045,14.675 26.046,14.675 Z M26.046,5.246 C29.582,5.246 32.2165,7.8345 32.2165,11.1855 C32.2165,14.5365 29.582,17.125 26.046,17.125 C22.5105,17.125 19.8755,14.5365 19.8755,11.1855 C19.8755,7.8345 22.5105,5.246 26.046,5.246 L26.046,5.246 Z"
            id="MomentiveLogoTypeGroupFill4"
          />
          <path
            d="M62.9025,10.007 C62.6945,8.2965 61.4465,7.511 60.1755,7.511 C58.881,7.511 57.587,8.2965 57.24,10.007 L62.9025,10.007 Z M57.24,11.948 C57.587,13.843 59.089,14.8135 61.0075,14.8135 C62.44,14.8135 63.4695,14.45 64.8895,13.934 L64.8895,16.0615 C63.8265,16.732 62.209,17.125 60.73,17.125 C57.0785,17.125 54.3975,14.7675 54.3975,11.2085 C54.3975,7.603 57.1015,5.246 60.198,5.246 C63.0175,5.246 65.5135,7.1645 65.5135,10.8155 C65.5135,11.1855 65.4905,11.6475 65.4445,11.948 L57.24,11.948 L57.24,11.948 Z"
            id="MomentiveLogoTypeGroupFill5"
          />
          <path
            d="M116.0125,10.007 C115.8045,8.2965 114.5565,7.511 113.2855,7.511 C111.991,7.511 110.6975,8.2965 110.3505,10.007 L116.0125,10.007 Z M110.3505,11.948 C110.6975,13.843 112.199,14.8135 114.1175,14.8135 C115.5505,14.8135 116.58,14.45 118,13.934 L118,16.0615 C116.937,16.732 115.3195,17.125 113.8405,17.125 C110.1885,17.125 107.508,14.7675 107.508,11.2085 C107.508,7.603 110.212,5.246 113.3085,5.246 C116.128,5.246 118.624,7.1645 118.624,10.8155 C118.624,11.1855 118.601,11.6475 118.5545,11.948 L110.3505,11.948 L110.3505,11.948 Z"
            id="MomentiveLogoTypeGroupFill6"
          />
          <path
            d="M77.497,6.4475 C76.781,5.662 75.745,5.219 74.52,5.219 C72.075,5.219 69.6985,6.092 67.9295,6.7435 L67.9295,16.8705 L70.726,16.8705 L70.726,7.719 L73.707,7.719 C74.354,7.719 74.863,7.927 75.2095,8.343 C75.5325,8.7125 75.6715,9.2675 75.6715,10.284 L75.6715,16.8705 L78.468,16.8705 L78.468,9.799 C78.468,8.112 78.1675,7.1645 77.497,6.4475"
            id="MomentiveLogoTypeGroupFill7"
          />
          <path
            d="M90.5,16.8705 L93.2965,16.8705 L93.2965,5.5005 L90.5,5.5005 L90.5,16.8705 Z M91.9095,0 C92.8575,0 93.643,0.786 93.643,1.7335 C93.643,2.681 92.8575,3.4665 91.8865,3.4665 C90.939,3.4665 90.1535,2.681 90.1535,1.7335 C90.1535,0.786 90.939,0 91.9095,0 L91.9095,0 Z"
            id="MomentiveLogoTypeGroupFill8"
          />
          <path
            d="M95.025,5.5005 L97.983,5.5005 L99.6005,9.66 C100.086,10.908 100.5715,12.179 101.0565,13.5195 L101.103,13.5195 C101.6115,12.179 102.0735,11.0005 102.605,9.6835 L104.292,5.5005 L107.135,5.5005 L102.4665,16.8705 L99.7165,16.8705 L95.025,5.5005"
            id="MomentiveLogoTypeGroupFill9"
          />
          <path
            d="M88.009,7.8805 L88.009,5.5 L84.7965,5.5 L84.7965,1.9185 L82,2.774 L82,5.5 L80.0125,5.5 L80.0125,7.8805 L82,7.8805 L82,12.757 C82,14.444 82.3465,15.3915 82.9245,16.0155 C83.6405,16.8245 84.704,17.125 85.698,17.125 C86.5755,17.125 87.5005,16.894 88.009,16.5935 L88.009,14.338 C87.528,14.5295 86.8995,14.767 86.2985,14.767 C85.0275,14.767 84.7965,13.704 84.7965,12.433 L84.7965,7.8805 L88.009,7.8805"
            id="MomentiveLogoTypeGroupFill10"
          />
        </g>
      </g>
    </svg>
  );
}

export default MomentiveLogoType;
